import React, { useEffect, useState } from "react";
import "../css/main.css";
import "../css/util.css";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
import EnhancedEncryptionIcon from "@mui/icons-material/EnhancedEncryption";
import {
  Alert,
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import jwtDecode from "jwt-decode";
import { useMediaQuery } from "react-responsive";
import { Straight } from "@mui/icons-material";
import { RTKUseMutation } from "../components/RQUseQueryHook.ts";

const styles = {
  checkBoxGroup: {
    display: "flex",
    flexDirection: "row",
    borderBottom: "2px solid #466274",
    marginBottom: "30px",
  },
  infoBox: {
    position: "absolute",
    width: "20rem",
    height: "20.2rem",
    backgroundColor: "#fff",
    borderRadius: "0.7rem",
    right: "12rem",
    top: "4rem",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    zIndex: "10",
    display: "flex",
    justifyContent: "inherit",
    flexDirection: "column",
    padding: "1rem",
  },
  mobileInfoBox: {
    width: "31rem",
    height: "26rem",
    backgroundColor: "#fff",
    borderRadius: "0.7rem",
    right: "12rem",
    top: "4rem",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    zIndex: "10",
    display: "flex",
    justifyContent: "inherit",
    flexDirection: "column",
    padding: "1rem",
    marginBottom: "1rem",
  },
  tabletInfoBox: {
    width: "31rem",
    height: "20rem",
    backgroundColor: "#fff",
    borderRadius: "0.7rem",
    right: "12rem",
    top: "4rem",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    zIndex: "10",
    display: "flex",
    justifyContent: "inherit",
    flexDirection: "column",
    padding: "1rem",
    marginBottom: "1rem",
  },
  infoHelperBox: {
    position: "absolute",
    width: "20rem",
    left: "2rem",
    backgroundColor: "#fff",
    borderRadius: "0.7rem",
    top: "33rem",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    zIndex: "10",
    display: "flex",
    justifyContent: "inherit",
    flexDirection: "column",
    padding: "1rem",
  },
  mobileInfoHelperBox: {
    width: "31rem",
    height: "12rem",
    backgroundColor: "#fff",
    borderRadius: "0.7rem",
    left: "12rem",
    top: "4rem",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    zIndex: "10",
    display: "flex",
    justifyContent: "inherit",
    flexDirection: "column",
    padding: "1rem",
    marginBottom: "1rem",
  },
  pointerBox: {
    width: "100%",
    display: "flex",
    transform: "rotate(180deg)",
  },
  forwardTab: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  notHaveRequestCodeContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100% ",
  },
};

function Login() {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  // const [rememberMe, setRememberMe] = useState(false);
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [isShowConfirmPassword, setIsShowConfirmPassword] = useState(false);
  const [userType, setUserType] = useState("مشتری");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const [loginStatus, setLoginStatus] = useState(true);
  const [HaveRequestCode, setHaveRequestCode] = useState<boolean>(true);
  const [userInfo, setUserInfo] = useState({
    username: "",
    password: "",
  });
  const token = localStorage.getItem("token");
  let decode: any = {};

  useEffect(() => {
    if (token) {
      decode = jwtDecode(token);
    }
  }, []);

  const handleChangeInput = (event) => {
    setUserInfo({
      ...userInfo,
      [event.target.name]: event.target.value,
    });
  };
  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isTablet = useMediaQuery({
    query: "((min-width:650px) and (max-width: 900px))",
  });

  const isMobile = useMediaQuery({
    query: "(max-width: 420px)",
  });
  // postRequests ////////////////////////////
  const onSuccessCustomerLogin = (data) => {
    if (data.message === "ok") {
      localStorage.setItem("token", data.data.token);
      localStorage.setItem("user", data.data.user.userName);
      toast.success("ورود با موفقیت انجام شد!");
      setTimeout(() => {
        window.location.replace(`/adminRequestHistory`);
      }, 2000);
    }
  };
  const onErrorCustomerLogin = (err) => {
    toast.error(err);
  };
  const { mutate: CustomerLogin } = RTKUseMutation(
    `${process.env.REACT_APP_BASE_URL}/User/CustomerLogin`,
    userInfo,
    "registerData",
    onSuccessCustomerLogin,
    onErrorCustomerLogin
  );

  const onSuccessUserLogin = (data) => {
    localStorage.setItem(
      "userLevel",
      JSON.stringify({
        charense_Amount: data.data.charense_Amount,
        charense_level_ID: data.data.charense_level_ID,
        charense_level_Title: data.data.charense_level_Title,
      })
    );
    localStorage.setItem("token", data.data.token);
    localStorage.setItem("user", data.data.user.userName);
    toast.success("ورود با موفقیت انجام شد!");
    setTimeout(() => {
      window.location.replace(`/RequestDetails/${data.data.user.userName}`);
    }, 2000);
  };
  const onErrorUserLogin = (err) => {
    toast.error(err);
  };
  const { mutate: UserLogin } = RTKUseMutation(
    `${process.env.REACT_APP_BASE_URL}/User/UserLogin`,
    userInfo,
    "UserLogin",
    onSuccessUserLogin,
    onErrorUserLogin
  );

  const onSuccessCustomerRegister = (data) => {
    toast.success("ثبت نام موفقیت آمیز بود. لطفا مجدداّ وارد شوید");
  };
  const onErrorCustomerRegister = (err) => {
    toast.error(err);
  };
  const { mutate: CustomerRegister } = RTKUseMutation(
    `${process.env.REACT_APP_BASE_URL}/Account/login`,
    userInfo,
    "CustomerRegister",
    onSuccessCustomerRegister,
    onErrorCustomerRegister
  );

  const onSuccessAccountLogin = (data) => {
    localStorage.removeItem("token");
    localStorage.setItem("token", data.data.token);
    toast.success("ورود با موفقیت انجام شد!");
    setTimeout(() => {
      window.location.replace("/searchRequest");
    }, 2000);
  };
  const onErrorAccountLogin = (err) => {
    toast.error(err);
  };
  const { mutate: AccountLogin } = RTKUseMutation(
    `${process.env.REACT_APP_BASE_URL}/Account/login`,
    userInfo,
    "loginData",
    onSuccessAccountLogin,
    onErrorAccountLogin
  );

  // /////////////////////////////////////////
  const handleSubmitForm = async (e) => {
    e.preventDefault();
    if (!HaveRequestCode) {
      CustomerLogin();
    } else {
      if (userType === "مشتری") {
        UserLogin();
      } else {
        AccountLogin();
      }
    }
  };
  const handleSignin = async (e) => {
    e.preventDefault();
    if (
      !isNaN(+userInfo.username) &&
      userInfo.username.length >= 10 &&
      userInfo.username.length <= 11
    ) {
      if (confirmPassword === userInfo.password) {
        CustomerRegister();
      } else {
        toast.error("تکرار رمز عبور اشتباه است!");
      }
    } else {
      toast.error("کد ملی وارد شده صحیح نیست!");
    }
  };
  const handleChange = (event: SelectChangeEvent) => {
    setUserType(event.target.name);
  };

  return (
    <div>
      <div className="limiter">
        <div className="container-login100">
          <Box
            sx={
              isDesktop
                ? styles.infoBox
                : isTablet
                ? styles.tabletInfoBox
                : styles.mobileInfoBox
            }
          >
            <Alert severity="error" sx={{ justifyContent: "center" }}>
              <Typography variant="body1" color="initial">
                قابل توجه کاربران محترم
              </Typography>
            </Alert>
            <Typography
              variant="body1"
              color="initial"
              sx={{
                padding: "1rem 0px",
                lineHeight: "2",
                textAlign: "justify",
              }}
            >
              {" "}
              جهت ورود به سیستم
              <span style={{ fontWeight: "bold" }}> نام کاربری شما، </span>
              <span style={{ color: "red" }}>
                کد درخواست نیما یا کد رهگیری سنا{" "}
              </span>{" "}
              و<span style={{ fontWeight: "bold" }}> رمز عبور</span> شما
              <span style={{ color: "red" }}> شناسه ملی</span> می باشد.
              <br />
              در صورت{" "}
              <span style={{ color: "red" }}>
                فراموشی یا نداشتن کد درخواست{" "}
              </span>{" "}
              می توانید با استفاده از گزینه
              <span style={{ fontWeight: "bold" }}>
                {" "}
                کد درخواست ندارید؟
              </span>{" "}
              جهت ثبت نام یا ورود با کد ملی خود اقدام نمایید.
            </Typography>
            {isMobile || isTablet ? (
              <Typography
                variant="body1"
                color="initial"
                sx={{ lineHeight: "2", textAlign: "justify" }}
              >
                کاربران عزیز جهت ارتباط با
                <span style={{ fontWeight: "bold" }}> بخش پشتیبانی</span> از
                دکمه <span style={{ color: "red" }}>قرمز</span> رنگ پایین صفحه
                استفاده کرده و برای واحد پشتیبانی پیغام بگذارید. واحد پشتیبانی
                در اسرع وقت پاسخگوی شما خواهد بود.
              </Typography>
            ) : null}
          </Box>
          {isMobile || isTablet ? null : (
            <Box
              sx={isDesktop ? styles.infoHelperBox : styles.mobileInfoHelperBox}
            >
              <Alert severity="warning" sx={{ justifyContent: "center" }}>
                <Typography variant="body1" color="initial">
                  راهنمای ارتباط با پشتیبانی سامانه
                </Typography>
              </Alert>
              <Typography
                variant="body1"
                color="initial"
                sx={{
                  padding: "1rem 0px 0px 0px",
                  lineHeight: "2",
                  textAlign: "justify",
                }}
              >
                کاربران عزیز جهت ارتباط با
                <span style={{ fontWeight: "bold" }}> بخش پشتیبانی</span> از
                دکمه <span style={{ color: "red" }}>قرمز</span> رنگ پایین صفحه
                استفاده کرده و برای واحد پشتیبانی پیغام بگذارید. واحد پشتیبانی
                در اسرع وقت پاسخگوی شما خواهد بود.
              </Typography>
              <Box style={styles.pointerBox}>
                <Straight className="pointerInSlide " />
              </Box>
            </Box>
          )}
          <div className="loginContainer">
            <div className="wrap-login100">
              <form className="login100-form validate-form">
                <span className="login100-form-logo">
                  <img
                    src={require("../assets/logo/charismaLogo.png")}
                    style={{ width: "15rem" }}
                    alt="charisma logo"
                  />
                </span>

                <span className="login100-form-title p-b-34 p-t-27">
                  سامانه ارتباط با مشتریان صرافی کاریزما
                </span>
                {HaveRequestCode ? (
                  <>
                    <Typography sx={{ color: "#fff" }}>نقش کاربر:</Typography>
                    <FormGroup sx={styles.checkBoxGroup}>
                      <FormControlLabel
                        sx={{ color: "#fff" }}
                        control={
                          <Checkbox
                            checked={userType === "مشتری" ? true : false}
                            color="default"
                            name="مشتری"
                            sx={{ color: "#fff" }}
                            onChange={handleChange}
                          />
                        }
                        label="مشتری"
                      />
                      <FormControlLabel
                        sx={{ color: "#fff" }}
                        control={
                          <Checkbox
                            checked={userType === "کارشناس" ? true : false}
                            color="default"
                            name="کارشناس"
                            sx={{ color: "#fff" }}
                            onChange={handleChange}
                          />
                        }
                        label="کارشناس"
                      />
                    </FormGroup>
                  </>
                ) : null}
                <div
                  className="wrap-input100 validate-input"
                  data-validate="Enter username"
                >
                  <AccountCircleIcon
                    style={{ color: "#fff", marginTop: "0.5rem" }}
                  />
                  <input
                    className="input100"
                    type="text"
                    name="username"
                    onChange={handleChangeInput}
                    placeholder={
                      !loginStatus && !HaveRequestCode ? "کد ملی" : "نام کاربری"
                    }
                  />
                </div>

                <div
                  className="wrap-input100 validate-input"
                  data-validate="Enter Password"
                >
                  <LockIcon style={{ color: "#fff", marginTop: "0.5rem" }} />
                  <input
                    className="input100"
                    type={isShowPassword ? "text" : "password"}
                    name="password"
                    onChange={handleChangeInput}
                    placeholder="رمز عبور"
                  />
                  <IconButton
                    onClick={() => setIsShowPassword(!isShowPassword)}
                  >
                    {isShowPassword ? (
                      <VisibilityOffIcon sx={{ color: "#fff" }} />
                    ) : (
                      <VisibilityIcon sx={{ color: "#fff" }} />
                    )}
                  </IconButton>
                </div>
                {!loginStatus && !HaveRequestCode ? (
                  <div
                    className="wrap-input100 validate-input"
                    data-validate="Enter Password"
                  >
                    <EnhancedEncryptionIcon
                      style={{ color: "#fff", marginTop: "0.5rem" }}
                    />
                    <input
                      className="input100"
                      type={isShowConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder=" تکرار رمز عبور"
                    />
                    <IconButton
                      onClick={() =>
                        setIsShowConfirmPassword(!isShowConfirmPassword)
                      }
                    >
                      {isShowConfirmPassword ? (
                        <VisibilityOffIcon sx={{ color: "#fff" }} />
                      ) : (
                        <VisibilityIcon sx={{ color: "#fff" }} />
                      )}
                    </IconButton>
                  </div>
                ) : null}
                <div className="contact100-form-checkbox">
                  {HaveRequestCode ? (
                    <label
                      className="label-checkbox100"
                      onClick={() =>
                        setHaveRequestCode((prevstate) => !prevstate)
                      }
                    >
                      کد درخواست ندارید؟
                    </label>
                  ) : (
                    <div style={styles.notHaveRequestCodeContainer}>
                      <label
                        className="label-checkbox100"
                        onClick={() =>
                          setHaveRequestCode((prevstate) => !prevstate)
                        }
                      >
                        ورود با کد درخواست
                      </label>
                      {loginStatus ? (
                        <label
                          className="label-checkbox100"
                          onClick={() =>
                            setLoginStatus((prevstate) => !prevstate)
                          }
                        >
                          ثبت نام
                        </label>
                      ) : (
                        <label
                          className="label-checkbox100"
                          onClick={() =>
                            setLoginStatus((prevstate) => !prevstate)
                          }
                        >
                          ورود
                        </label>
                      )}
                    </div>
                  )}
                </div>
                {!loginStatus && !HaveRequestCode ? (
                  <div className="container-login100-form-btn">
                    <button
                      className="login100-form-btn"
                      onClick={handleSignin}
                    >
                      ثبت نام
                    </button>
                  </div>
                ) : (
                  <div className="container-login100-form-btn">
                    <button
                      className="login100-form-btn"
                      onClick={handleSubmitForm}
                    >
                      ورود
                    </button>
                  </div>
                )}

                {/* <div className="text-center p-t-90">
                <a className="txt1" href="#">
                  فراموشی رمز عبور؟
                </a>
              </div> */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
